import React from 'react';
import {reset} from 'redux-form';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import { stopSubmit, formValueSelector } from 'redux-form'
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import * as colors from 'material-ui/styles/colors';

import moment from 'moment'
import _ from 'lodash'

import PageBase from '../../components/PageBase';
import DataTables from '../../components/DataTables/DataTables'

import listHeader from './listHeader'
import gStyles from '../../styles'

import RoumuListForm from './RoumuListForm'

import * as actions from '../../actions'

const MASTER_TYPE = "roumu"

const validate = values => {
  const errors = {}
  const requiredFields = [
    "branchOfficeId",
    "departmentId",
    "name",
    "email",
    "password",
    "paidHoliday",
    "priceId",
    "permission",
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })
  if (values.paidHoliday && !/^([1-9]\d*|0)(\.\d+)?$/.test(values.paidHoliday)) {
    errors.paidHoliday = '数値を入力して下さい'
  }
  return errors
}

const validateSearch = values => {
  const errors = {}
  if (values.paidHoliday && !/^([1-9]\d*|0)(\.\d+)?$/.test(values.paidHoliday)) {
    errors.paidHoliday = '数値を入力して下さい'
  }
  return errors
}

class RoumuListPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      open: false
    }
  }

  componentDidMount() {
    const {
      form,
      page
    } = this.props

    this.props.handleInit(form, page)
  }


  handlePreviousPageClick(form, page, editIndex) {
    const prevPage = page - 1
    this.props.handlePageClick(prevPage, form)
  }

  handleNextPageClick(form, page, editIndex) {
    const nextPage = page + 1
    this.props.handlePageClick(nextPage, form)
  }

  handleConfirmOpen(id, item) {
    this.setState(Object.assign({}, this.state, {
      id: id,
      item: item,
      open: true
    }))
  }

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false
    }))
  }

  handlePageReset() { 
    this.setState(Object.assign({}, this.state, {
      page: 1
    }))
  }

  render() {

    const {
      auth,
      selectData,
      selectedBranchOfficeId,
      handleFormSearchClick,
      handleFormResetClick,
      handleLocalStorageSave,
      history,
    } = this.props


    const page = this.props.page
    const count = this.props.count
    const form = this.props.form || {}
    const list = this.props.list || []


    const dataList = list.map((x, index) => {

      const approvalDateParam = moment(x.approvalDate, 'YYYY/MM/DD').format('YYYYMMDD')

      const actions = (
        <div style={{display: "flex", justifyContent: 'flex-end'}}> 
          <div style={{ margin: '10px 10px' }}> 

            <Link className="button" to={`/roumu/${x.id}/${approvalDateParam}`}>
              <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400}> 
                <ContentCreate /> 
              </FloatingActionButton> 
            </Link>

          </div> 
        </div>
      )

      return {
        branchOfficeName: x.branchOfficeName,
        departmentName: x.departmentName,
        name: x.name,
        approvalDate: x.approvalDate,
        actions: actions,
      }

    })

    return (

      <PageBase title="未承認一覧" >

        <div>

          { auth.user.permission == 2 && (
            <div style={gStyles.searchBoxContainer}>

              <Paper style={{...gStyles.contentsPaper}}>
                  <RoumuListForm
                      selectedBranchOfficeId={selectedBranchOfficeId}
                      branchOfficeData={selectData.branchOffice}
                      departmentData={selectData.department}
                      onFormResetClick={handleFormResetClick}
                      onFormSearchClick={handleFormSearchClick(this.handlePageReset.bind(this))}
                      initialValues={form}
                      onLocalStorageSave={handleLocalStorageSave}
                  />
              </Paper>

            </div>
          )}

          <Paper style={{...gStyles.contentsPaper}}>
            <DataTables
              tableStyle={{overflow: 'hidden', tableLayout: ''}}
              tableBodyStyle={{overflowX: 'auto'}}
              height={'auto'}
              showRowHover={true}
              columns={listHeader}
              data={dataList}
              page={page}
              showRowSizeControls={false}
              onNextPageClick={this.handleNextPageClick.bind(this, form, page)}
              onPreviousPageClick={this.handlePreviousPageClick.bind(this, form, page)}
              count={count}
            />
          </Paper>

        </div>

      </PageBase>

    )
  }

}

const selector = formValueSelector(`${MASTER_TYPE}MasterForm`)
const mapStateToProps = (state) => ({
  auth: state.auth,
  list: state.master.list[MASTER_TYPE] ,
  count: state.master.count[MASTER_TYPE],
  form: state.master.form[MASTER_TYPE],
  page: state.master.page[MASTER_TYPE],
  selectData: state.master.selectData,
  selectedBranchOfficeId: selector(state, 'branchOfficeId'),
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : (form, page) => {dispatch(actions.systemMasterInit(MASTER_TYPE, form, page))},
  handleFormResetClick : () => {dispatch(actions.reducerMasterFormReset(MASTER_TYPE))},

  handleFormSearchClick : (pageReset) => (values) => {
    const errors = validateSearch(values)
    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`${MASTER_TYPE}MasterForm`, errors))
      return
    }
    pageReset()
    dispatch(actions.userMasterSearch(MASTER_TYPE, 1, values))
  },
  handlePageClick : (page, form) => {
    dispatch(actions.userMasterSearch(MASTER_TYPE, page, form))
  },
  handleLocalStorageSave : (values) => {
    if (!window.localStorage) {
      window.alert('お使いのブラウザでは固定できません。他のブラウザを使用して下さい。')
      return
    }
    window.localStorage.setItem(MASTER_TYPE, JSON.stringify(values))
    dispatch(actions.reducerSnackBar(true, '入力値を固定しました。', colors.green400))
  },
})

RoumuListPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(RoumuListPage)

export default RoumuListPage;



// WEBPACK FOOTER //
// ./src/containers/roumu/RoumuListPage.js